import * as Constants from '../../constants';

import { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import classes from "./WalletFIIsList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faExternalLink, faPlusCircle, faFileDownload, faFileUpload } from "@fortawesome/free-solid-svg-icons";

import { Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';

import AssetForm from '../../components/AssetForm';
import ScrollContainer from '../../components/UI/ScrollContainer';
import ConfirmDialog from '../../components/UI/ConfirmDialog';

import { CSVLink } from "react-csv";
import Papa from 'papaparse';

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const defaultFormAsset = { id: 0, ticker: "", quotas: 0, price: 0 };

function WalletFiisList(props) {
  const csvUploadFileRef = useRef();
  const total = useSelector(state => state.total);

  const [fiis, setFiis] = useState([]);
  const [allFiis, setAllFiis] = useState([]);
  const [totalFiis, setTotalFiis] = useState(0);
  const [totalInvestidoFIIs, setTotalInvestidoFIIs] = useState(0);
  const [rentabilidadeTotal, setRentabilidadeTotal] = useState(0);
  const [formIsShown, setFormIsShown] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteConfirmationIsShown, setDeleteConfirmationIsShown] = useState(false);
  const [deleteWalletConfirmationIsShown, setDeleteWalletConfirmationIsShown] = useState(false);
  const [selectedWalletItem, setSelectedWalletItem] = useState(defaultFormAsset);
  const threshold = localStorage.getItem('threshold');

  const assetSubmitHandler = async () => {
    await fetchFiisHandler();
    hideFormHandler();
  };

  const hideFormHandler = () => {
    setFormIsShown(false);
  };

  const deleteConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      const response = await fetch(Constants.DELETE_WALLET_ASSET, {
        method: "DELETE",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "id": selectedWalletItem.id })
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
    }
    setSelectedWalletItem({});
    setDeleteConfirmationIsShown(false);
    fetchFiisHandler();
    props.onUpdateAssets(totalInvestidoFIIs, totalFiis);
    props.setIsLoading(false);
  };

  const hideDeleteConfirmationHandler = () => {
    setDeleteConfirmationIsShown(false);
  };

  const hideDeleteWalletConfirmationHandler = () => {
    setDeleteWalletConfirmationIsShown(false);
  };

  const deleteHandler = (id) => {
    const title = fiis.filter((el) => { return el.id === id })[0].ticker;
    setSelectedWalletItem({ id, title });
    setDeleteConfirmationIsShown(true);
  };

  const addHandler = (id) => {
    setSelectedWalletItem(defaultFormAsset);
    setEditMode(false);
    setFormIsShown(true);
  };

  const deleteWalletConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      const response = await fetch(Constants.DELETE_WALLET_ASSET, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "class": 2 })
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
      console.warn(error);
    }
    setDeleteWalletConfirmationIsShown(false);
    fetchFiisHandler();
    props.onUpdateAssets(totalInvestidoFIIs, totalFiis);
    props.setIsLoading(false);
  };

  const deleteWalletHandler = () => {
    // const title = acoes.filter((el) => { return el.id === id })[0].codigo;
    setDeleteWalletConfirmationIsShown(true);
  };

  const submitAssetListHandler = async (data) => {
    // console.log(data);
    let pData = [];
    data.forEach(asset => {
      const assetData = {
        id: asset[1],
        quotas: asset[0],
        averagePrice: asset[2].replace(",", ".")
      };
      pData.push(assetData);
    });
    // console.log(pData);
    const listData = {
      class: 2,
      data: pData
    }

    const id = localStorage.getItem("id");
    const url = `${Constants.ADD_ASSET_LIST}?id=${id}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(listData)
    });
    // console.log(response);
    // onFinishSubmit(pData);
  };

  const uploadButtonHandler = () => {
    csvUploadFileRef.current.click();
  };

  const csvUploadHandler = (event) => {
    const fileObj = event.target.files && event.target.files[0];
    // console.log(fileObj);

    Papa.parse(fileObj, {
      skipEmptyLines: true,
      complete: function (results) {
        // for (const entry of Object.entries(results.data)) {
        // console.log(results);
        submitAssetListHandler(results.data);
        // }
      }
    });

    fetchFiisHandler();
  };

  const editHandler = (id) => {
    const filtered = fiis.filter((el) => { return el.id === id })[0];
    const selected = allFiis.filter((el) => { return el.title === filtered.ticker })[0];

    setSelectedWalletItem({
      id,
      ticker: selected.title,
      quotas: Number(filtered.quantidade),
      price: Number(filtered.price)
    });
    setEditMode(true);
    setFormIsShown(true);
  };

  const fetchAllFiisHandler = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(Constants.WALLET_FIIS_LIST, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });      

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
      const data = await response.json();
      setAllFiis(data);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  const fetchFiisHandler = useCallback(async () => {
    props.setIsLoading(true);
    let rentabilidade = 0;
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(Constants.WALLET_FIIS_LIST, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });      
      
      if (!response.ok) {
        throw new Error('Something went wrong!');
      }

      const data = await response.json();
      let sum = 0;
      let sumInvestido = 0;
      const loadedFIIs = [];

      for (let item of data) {
        let investido = item.price * item.quantity;
        let atual = item.currentPrice * item.quantity;

        let fii = {
          id: item.id,
          ticker: item.title,
          quantidade: item.quantity,
          setor: item.sector,
          subsetor: item.subsector,
          price: item.price,
          currentPrice: item.currentPrice,
          valorInvestido: investido,
          valorAtual: atual,
          rentabilidadePercentual: (atual - investido) / investido,
          rentabilidadeAbsoluta: (atual - investido),
          parcelaTotalGeral: atual
        }

        const indicators = item.indicators;
        for (const [indicator, value] of Object.entries(indicators)) {
          fii[indicator] = value;
        }
        fii['yoc'] = ((Number(item.indicators.d.replace(",", ".")) / Number(item.price) * 100).toFixed(2));

        sum += fii.valorAtual;
        sumInvestido += fii.valorInvestido;
        rentabilidade += fii.rentabilidadeAbsoluta;
        loadedFIIs.push(fii);
      }
      setTotalFiis(sum);
      setTotalInvestidoFIIs(sumInvestido);
      setFiis(loadedFIIs);
      setRentabilidadeTotal(rentabilidade);
      props.onUpdateAssets(sumInvestido, sum);
      props.setIsLoading(false);
    } catch (error) {
      console.warn(error);
    }
    props.setIsLoading(false);
  }, [total, fiis, totalFiis]);

  useEffect(() => {
    fetchAllFiisHandler();
    fetchFiisHandler();
  }, []);

  useEffect(() => {
    props.onUpdateAssets(totalInvestidoFIIs, totalFiis);
    props.setIsLoading(false);
  }, [total, totalFiis, fiis]);

  const csvDownloadHandler = () => {
    let fiisCopy = [];
    fiis.forEach(object => {
      const obj = {
        cotas: object.quantidade,
        codigo: object.codigo,
        price: object.price,
        id: object.id
      }
      fiisCopy.push(obj);
    });
    return fiisCopy;
  }

  const confirmMessage = <>Tem certeza que deseja excluir o ativo <b>{selectedWalletItem.title}</b>?</>;
  const confirmDeleteWalletMessage = <>Tem ecrteza que deseja excluir todos os ativos?</>;

  return <>
    {formIsShown && <AssetForm
      edit={editMode}
      active={selectedWalletItem}
      assets={allFiis}
      method="POST"
      onFinishSubmit={assetSubmitHandler}
      onClose={hideFormHandler}
    />}
    {deleteConfirmationIsShown && <ConfirmDialog
      variant="warning"
      onConfirm={deleteConfirmationHandler}
      onCancel={hideDeleteConfirmationHandler}
      header="Atenção!"
      message={confirmMessage}
    />}
    {deleteWalletConfirmationIsShown && <ConfirmDialog
      variant="danger"
      onConfirm={deleteWalletConfirmationHandler}
      onCancel={hideDeleteWalletConfirmationHandler}
      header="Atenção!"
      message={confirmDeleteWalletMessage}
    />}

    {!props.isLoading &&
      <>
        <div className='row'>
          <div className='col col-md-2'>
            <Button onClick={addHandler} variant="primary" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faPlusCircle} />&nbsp;Adicionar
            </Button>

            <Button onClick={uploadButtonHandler} variant="outline-primary" type="button" size="sm" className="m-1" title="Enviar CSV">
              <input
                ref={csvUploadFileRef}
                onChange={csvUploadHandler}
                type="file"
                accept="text/csv"
                style={{ display: "none" }}
              />
              <FontAwesomeIcon icon={faFileUpload} />
            </Button>

            <CSVLink data={csvDownloadHandler()} filename={"fiis.csv"}>
              <Button variant="outline-success" type="button" size="sm" className="m-1" title="Baixar CSV">
                <FontAwesomeIcon icon={faFileDownload} />
              </Button>
            </CSVLink>

            <Button onClick={deleteWalletHandler} variant="outline-danger" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>

          <div className='col col-md-2'>
            <span className="fw-bold">Total Geral:</span> {brlFormatter.format(total)}
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total Investido em FIIs:</span><br /><small>{brlFormatter.format(totalInvestidoFIIs)} em 
            <span className="fw-bold"> {fiis.length}</span> ativos</small>
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total em FIIs:</span> {isNaN(totalFiis) || totalFiis === 0 ? '0%' : percentageFormatter.format(totalFiis / total)}<br/><small>{brlFormatter.format(totalFiis)}</small>
          </div>

          <div className='col col-md-2'>
            <span className={(rentabilidadeTotal >= 0 ? 'fw-bold positive' : 'fw-bold negative')}>Rentabilidade:</span> {isNaN(rentabilidadeTotal) || rentabilidadeTotal === 0 ? '0%' : percentageFormatter.format(rentabilidadeTotal / totalFiis)}<br/><small>{brlFormatter.format(rentabilidadeTotal)}</small>
          </div>
        </div>

        <ScrollContainer heightMultiplier={0.6337}>
          <Table striped bordered hover>
            <thead className={`fixedTableHead`}>
              <tr>
                <th rowSpan="2" className={classes.th}>Cotas</th>
                <th rowSpan="2" className={classes.th}>Código</th>
                <th rowSpan="2" className={classes.th}>Setor<br />Segmento</th>
                <th rowSpan="2" className={classes.th}>Rendimento<br /> x Poupança</th>
                <th rowSpan="2" className={classes.th}>PVP</th>
                <th colSpan="6" className={classes.th}>Dividend Yield</th>
                <th colSpan="3" className={classes.th}>Variação</th>
                <th colSpan="2" className={classes.th}>Preço</th>
                <th colSpan="2" className={classes.th}>Valor</th>
                <th rowSpan="2" className={classes.th}>% Geral<br />% Na Classe</th>
                <th rowSpan="2" className={classes.th}>Rentabilidade</th>
                <th rowSpan="2" className={classes.th}>Operações</th>
              </tr>
              <tr>
                <th className={classes.th}>YOC</th>
                {/* <th className={classes.th}>Último</th> */}
                <th colSpan="1" className={classes.th}>1 Mês</th>
                <th className={classes.th}>3 Meses</th>
                <th className={classes.th}>6 Meses</th>
                <th className={classes.th}>12 Meses</th>
                <th className={classes.th}>IPO</th>
                <th className={classes.th}>1 Dia</th>
                <th className={classes.th}>1 Mês</th>
                <th className={classes.th}>1 Ano</th>
                <th className={classes.th}>Médio</th>
                <th className={classes.th}>Atual</th>
                <th className={classes.th}>Investido</th>
                <th className={classes.th}>Atual</th>
              </tr>
            </thead>
            <tbody>
              {fiis.length === 0 && <tr>
                <td colSpan='24'>Nenhum ativo cadastrado.</td>
              </tr>
              }
              {
                fiis.map((fii) => <tr key={fii.id}>
                  <td className={classes.td}>{fii.quantidade}</td>
                  <td className={classes.td + " text-center"}>
                    <span className={"font-weight-bold"}>{fii.ticker}</span><br />
                    <a href={`${Constants.BASE_URL_BRA_FII_INVESTIDOR10}${fii.ticker}`} target='_blank' rel="noreferrer" title='Investidor10'>
                      <FontAwesomeIcon icon={faExternalLink} />
                    </a>&nbsp;&nbsp;
                    <a href={`${Constants.BASE_URL_BRA_FII_FUNDSEXPLORER}${fii.ticker}`} target='_blank' rel="noreferrer" title='FundsExplorer'>
                      <FontAwesomeIcon icon={faExternalLink} />
                    </a>&nbsp;&nbsp;
                    <a href={`${Constants.BASE_URL_BRA_FII_INFOMONEY}${fii.ticker}`} target='_blank' rel="noreferrer" title='InfoMoney'>
                      <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                  </td>
                  <td className={classes.td}>{fii.setor}<br />{fii.subsetor}</td>
                  <td className={classes.td + "" + (fii.xPoupanca < 0 ? " text-danger" : "")}>{percentageFormatter.format(fii.xPoupanca / 100)}</td>
                  <td className={classes.td + "" + (fii.pvp < 1 ? " text-success" : "")}>{fii.pvp.replace(".",',')}</td>
                  <td className={classes.td + "" + (fii.yoc < fii.dy1 ? " text-danger" : "")}>{percentageFormatter.format(fii.yoc / 100)}</td>
                  <td className={classes.td}>{percentageFormatter.format(fii.dy1 / 100)}<br/>
                  {fii.d ? "R$ " + fii.d.replace(".", ",") : ""}</td>
                  <td className={classes.td}>{percentageFormatter.format(fii.dy3 / 100)}</td>
                  <td className={classes.td}>{percentageFormatter.format(fii.dy6 / 100)}</td>
                  <td className={classes.td}>{percentageFormatter.format(fii.dy12 / 100)}</td>
                  <td className={classes.td}>{percentageFormatter.format(fii.dyIPO / 100)}</td>
                  <td className={classes.td + "" + (fii.vD < 0 ? " text-danger" : "")}>{percentageFormatter.format(fii.vD / 100)}</td>
                  <td className={classes.td + "" + (fii.vM < 0 ? " text-danger" : "")}>{percentageFormatter.format(fii.vM / 100)}</td>
                  {/* <td className={classes.td}>{acao.vYTD}%</td> */}
                  <td className={classes.td + "" + (fii.vY < 0 ? " text-danger" : "")}>{percentageFormatter.format(fii.vY / 100)}</td>
                  <td className={classes.td +" "+ classes.emphasis + " fw-bold " + (fii.price > fii.currentPrice ? " text-danger" : " text-success")}>{brlFormatter.format(fii.price)}</td>
                  <td className={classes.td}>{brlFormatter.format(fii.currentPrice)}</td>
                  <td className={classes.td + (fii.valorInvestido > fii.valorAtual ? " text-danger" : "")}>{brlFormatter.format(fii.valorInvestido)}</td>
                  <td className={classes.td}>{brlFormatter.format(fii.valorAtual)}</td>
                  <td className={classes.td + "" + (fii.parcelaTotalGeral / total > threshold/100 ? " text-danger" : "")}>{percentageFormatter.format(fii.parcelaTotalGeral / total)}<br/>{percentageFormatter.format(fii.parcelaTotalGeral / totalFiis)}</td>
                  <td className={classes.td + (fii.rentabilidadePercentual < 0 ? " text-danger" : " text-success")}><strong>{percentageFormatter.format(fii.rentabilidadePercentual)}</strong><br/>
                    {brlFormatter.format(fii.rentabilidadeAbsoluta)}</td>
                  <td className={classes.td} style={{ textAlign: "center" }}>
                    <Link onClick={() => editHandler(fii.id)}><FontAwesomeIcon icon={faEdit} /></Link>&nbsp;&nbsp;&nbsp;
                    <Link onClick={() => deleteHandler(fii.id)}><FontAwesomeIcon icon={faTrash} /></Link>
                  </td>
                </tr>
                )
              }
            </tbody>
          </Table>
        </ScrollContainer>
      </>
    }
  </>
}

export default WalletFiisList;
